// Erkennung von Netzwerkausfaellen im Browser (DENO-J).
//
// `SelectionContext.loadSelection` meldete jeden Fehler nach Sentry -- auch
// den, den der Browser wirft, wenn die Verbindung zu Supabase gar nicht
// zustande kommt (`TypeError: Failed to fetch`). Die vier Events des Issues
// kamen alle aus HeadlessChrome (Crawler) und einem Tab, der waehrend des
// Ladens geschlossen oder offline gegangen ist. Kein Codepfad ist daran
// beteiligt, nichts davon ist behebbar, und Sentry gruppiert es als
// "Object captured as exception", weil supabase-js den TypeError in ein
// PostgrestError-aehnliches Objekt verpackt (`message: "TypeError: Failed to
// fetch"`, `code: ""`).
//
// Diese Datei erkennt genau diese Form. Ein Fehler MIT PostgREST-Code ist nie
// ein Netzwerkausfall -- der Code beweist, dass eine Antwort angekommen ist.

const NETWORK_FAILURE_PATTERNS: readonly RegExp[] = [
  /\bFailed to fetch\b/i, // Chromium
  /\bNetworkError when attempting to fetch resource\b/i, // Firefox
  /\bLoad failed\b/i, // Safari/WebKit
  /\bfetch failed\b/i,
  /\bnetwork request failed\b/i,
];

function textOf(err: unknown): string {
  if (typeof err === 'string') return err;
  if (err instanceof Error) return `${err.name}: ${err.message}`;
  if (err && typeof err === 'object') {
    const o = err as Record<string, unknown>;
    return [o.message, o.details].filter((v): v is string => typeof v === 'string').join('\n');
  }
  return '';
}

/**
 * true, wenn der Fehler ein Netzwerkausfall des Browsers ist (keine Antwort
 * vom Server), fuer den es keinen behebbaren Codepfad gibt.
 */
export function isNetworkFailure(err: unknown): boolean {
  if (err && typeof err === 'object' && !(err instanceof Error)) {
    const code = (err as { code?: unknown }).code;
    if (typeof code === 'string' && code.trim().length > 0) return false;
  }
  const text = textOf(err);
  if (text.length === 0) return false;
  return NETWORK_FAILURE_PATTERNS.some((re) => re.test(text));
}
